import { dayjs, isSameDay, dayjsLocal, timeZone } from "@/helpers/dayjs"

export default class CheckoutTimeUtil {
	constructor() {
		this.cacheTimes = null
		this.cachedOpeningHours = null
	}
	getDayTimes(openingTimes) {
		// if (this.cacheTimes) {
		// 	console.info("used cached times")
		// 	return this.cacheTimes
		// }

		const dayMap = {
			"monday": 1,
			"tuesday": 2,
			"wednesday": 3,
			"thursday": 4,
			"friday": 5,
			"saturday": 6,
			"sunday": 0,
		}
		this.cacheTimes = Object
			.entries(dayMap)
			.reduce((p, [k, v]) => {
				let openTimes = openingTimes.find(time => time.name == k)
				if (openTimes && typeof openTimes.open == "string" ) {
					//upgrade data
					openTimes.open = openTimes.open.split(":").map(v => parseInt(v))
					openTimes.close = openTimes.close.split(":").map(v => parseInt(v))
					//openTimes.openMs = openTimes.open[0] * 3600000 + openTimes.open[0] * 60000
					//openTimes.closeMs = openTimes.close[0] * 3600000 + openTimes.close[0] * 60000
				}
				p[v] = openTimes
				return p
			}, {})
		return this.cacheTimes
	}
	getMaxDate(openingTimes) {
		const openingHours = this.getOpeningHours(openingTimes)
		const lastTime = openingHours[openingHours.length - 1]
		if (lastTime) {
			return lastTime.end
		}
		return null
	}
	getMinDate(openingTimes, now) {
		const openingHours = this.getOpeningHours(openingTimes)
		const firstTime = openingHours.find(v => v.end.isAfter(now))
		if (firstTime) {
			return firstTime.start
		}
		return null
	}
	clearCache() {
		this.cachedOpeningHours = null
	}
	getOpeningHours(openingTimes) {
		if (this.cachedOpeningHours && this.cachedOpeningHours.length == openingTimes.length) {
			return this.cachedOpeningHours
		}
		
		this.cachedOpeningHours = openingTimes.map(v =>({
			start: dayjs(v.timelineStart).tz(timeZone),
			end: dayjs(v.timelineEnd).tz(timeZone)
		}))
		return this.cachedOpeningHours
	}
	getDisabledDates(openingTimes, minDate) {
		let times = this.getOpeningHours(openingTimes)
		let maxDate = this.getMaxDate(openingTimes).endOf('date')

		let checkDate = minDate
		let disabledDates = []
		while (checkDate.isBefore(maxDate)) {
			let dayEntry = times.find(v => isSameDay(v.start, checkDate))
			if (!dayEntry) {
				checkDate = checkDate.startOf('date')
				disabledDates.push(checkDate)
			}
			checkDate = checkDate.add(1, "day")
		}
		return disabledDates
	}
	

	isOpenAt(date, openingTimes) {
		let times = this.getOpeningHours(openingTimes)

		let open = times.find(v => !date.isBefore(v.start) && !date.isAfter(v.end))

		return open != null
	}

	getOrderTimes(openingTimes, orderDate, minDate) {
		let times = this.getOpeningHours(openingTimes)
		let checkDate = orderDate //dayjsLocal(orderDate)
		
		let orderTimes = []
		let dayTimes = times.filter(v => isSameDay(v.start, checkDate) && v.end.isAfter(minDate))
		if (dayTimes.length > 0) {
			let checkEntry = dayTimes.shift()
			let endOfDay = false
			let checkTime = checkEntry.start
			// HACK: we have to normalize the minutes to 15min
			let minute = checkTime.minute()
			checkTime = checkTime.add(Math.ceil(minute / 15) * 15 - minute, 'minute')
			checkTime = checkTime.second(0)
			
			while (checkEntry) {
				let afterEnd = checkTime.isAfter(checkEntry.end)
				let beforeStart = checkTime.isBefore(checkEntry.start)
				if (
						!checkTime.isBefore(minDate)
						&& !afterEnd 
						&& !beforeStart
					) {
					orderTimes.push(checkTime.format('HH:mm'))
					
				} else {
					// TODO: remove after we have enough tested
					false && console.debug(
						"not between",
						checkTime.format(),
						minDate.format(),
						checkEntry.start.format(),
						checkEntry.end.format(),
						!checkTime.isBefore(minDate),
						!afterEnd,
						!beforeStart
					)
				}
				if (afterEnd) {
					checkEntry = dayTimes.shift()
				} else {
					checkTime = checkTime.add(15, 'minutes')
				}
				
			}
		}
		// TODO: remove after we have enough tested
		false && console.debug(orderTimes, checkDate.format(), open.format(), close.format(), minDate.format(), checkDate.day())
		return orderTimes

	}
}